export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_USER_DATA = 'SET_USER_DATA';
export const LOG_OUT = 'LOG_OUT';
